import { connect } from 'react-redux';

import { actionGetDiscoverPlaceDetails } from 'store/actions';
import ManagerDiscoveryPlaceEdit from './ManagerDiscoveryPlaceEdit';

const mapStateToProps = (state) => ({
  discoverPlaceDetails: state.DiscoverPlace.discoverPlaceDetails,
  discoverPlaceDetailsLoading: state.DiscoverPlace.discoverPlaceDetailsLoading,
});

const mapDispatchToProps = ({
  actionGetDiscoverPlaceDetails,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManagerDiscoveryPlaceEdit);
